import React from 'react';

import Board from 'components/Board';
import Toast from 'components/Toast';
import Keyboard from 'components/Keyboard';
import { useNavigationBlocker } from 'common/hooks';

function Game() {
  useNavigationBlocker();

  return (
    <>
      <Toast />
      <Board />
      <Keyboard />
    </>
  );
}

export default Game;
